import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import "./adminDesktop.css";

export function AdminPlaceholderScreen({
  title,
  subtitle,
  onBack,
  children,
}) {
  return (
    <CrewPilotModuleShell
      title={title}
      subtitle={subtitle}
      sectionLabel="Administration"
      onBack={onBack}
      layout={PAGE_LAYOUT.FORM}
    >
      <div className="adm-narrow">
      <div className="rb-card">
        {children || (
          <p className="admin-placeholder-note">
            This section is planned for a future sprint. Existing workflows
            remain available through the Administration sidebar until migration
            is complete.
          </p>
        )}
      </div>
      </div>
    </CrewPilotModuleShell>
  );
}
